//
import cajaMachine from "./machine"
import { actionsNoCare } from "../../constants/actionsNoCare"

export const { initialState } = cajaMachine

const caja = (state = initialState, action) => {
  //
  if (
    !actionsNoCare.includes(action.type) &&
    !action.type.startsWith("@@") &&
    action.type.startsWith("caja/")
  ) {
    if (!cajaMachine.states[state.value]?.on?.[action.type]) {
      console.error(
        `cajaMachine: No hay transición definida para la acción ${action.type} en el estado ${state.value}`
      )
    } else {
      return cajaMachine.transition(state, action)
    }
  }
  return state
}

export default caja
